import FormInputs from "components/Form/FormInputs";
import ModalWindow from "components/ModalWindow";
import { Button, Icon } from 'semantic-ui-react'
import React, { useState, useMemo, useEffect } from 'react'
import { injectIntl } from "react-intl";

const ApplicationEditModal = ({ data, options, onConfirmEditModal, intl }) => {
  const [application, setApplication] = useState({});
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({})

  const editModalConfig = useMemo(() => {
    return {
      fieldsConfig: [
        {
          key: 1,
          name: "id",
          description: "",
          component: "input",
          inputProps: {},
          wrapperProps: {},
          titleProps: {},
          type: "",
          translatePath: "id",
          isHide: true,
          title: "id",
        },
        {
          key: 2,
          name: "nomenclature",
          description: "",
          component: "dropdown",
          options: options.cultures,
          type: "",
          translatePath: "title.culture",
          title: intl.formatMessage({ id: "title.culture" }),
        },
        {
          key: 3,
          name: "elevator",
          description: "",
          component: "dropdown",
          options: options.warehouses,
          type: "",
          translatePath: "title.elevator",
          title: intl.formatMessage({ id: "title.elevator" }),
        },
        {
          key: 4,
          name: "weight",
          description: "",
          component: "input",
          type: "",
          translatePath: "title.weight",
          title: intl.formatMessage({ id: "title.weight" }),
        },
        {
          key: 5,
          name: "scheduledDate",
          description: "",
          component: "datePicker",
          inputProps: { minDate: new Date() },
          type: "",
          translatePath: "title.scheduledDate",
          title: intl.formatMessage({ id: "title.scheduledDate" }),
        },
      ]
    };
  }, []);

  useEffect(() => {
    const tempEditData = {};
    for (const key in editModalConfig.fieldsConfig) {
      const name = editModalConfig.fieldsConfig[key].name;
      if (name === "elevator") {
        const res = options.warehouses.find(
          (el) => el.text === data[name]
        );
        if (res) tempEditData[name] = res.value;
      } else if (name === "nomenclature") {
        const res = options.cultures.find(
          (el) => el.text === data[name]
        );
        if (res) tempEditData[name] = res.value;
      } else {
        tempEditData[name] = data[name];
      }
    }
    setEditData(tempEditData);
  }, [options, data]);

  const onOpen = () => {
    setApplication({ ...editData, });
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onChange = ({ fieldName, value }) => {
    setApplication({ ...application, [fieldName]: value });
  };

  const onOk = async () => {
    await onConfirmEditModal(application);
  };

  const translates = useMemo(() => ({
    confirm: intl.formatMessage({ id: 'btn.suggest' }),
    cancel: intl.formatMessage({ id: 'btn.close' }),
    suggestChanges: intl.formatMessage({ id: 'btn.suggestChanges' }),
  }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

  const buttonModalActions = [
    { title: translates.confirm, color: "green", onClick: () => onOk() },
    { title: translates.cancel, color: "red", onClick: () => onClose() },
  ];

  return (
    <ModalWindow
      closeIcon
      iconType="info"
      title={translates.suggestChanges}
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      actions={buttonModalActions}
      trigger={
        <Button className="actionButton" icon>
          <Icon name="pencil alternate" /><span>{translates.suggestChanges}</span>
        </Button>
      }
    >
      <FormInputs
        fieldsConfig={editModalConfig.fieldsConfig}
        data={application}
        actions={{ onChange }}
      />
    </ModalWindow>
  );
};

export default injectIntl(ApplicationEditModal);
